
import {userSymbolsSlice} from "../../redux/userSymbolsReducer";
import {AppDispatch} from "../../redux/store";
import {siteOrigin, backendUrl} from "../../globalConfig";



export const getUserSymbols = () => async (dispatch: AppDispatch) => {
    fetch(backendUrl+'/user/get_user_symbols', {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': siteOrigin
        }
    })
        .then((r) =>  {
            if(r.status===200){
                return r.json().then(data => ({status: r.status, json: data}))
            } else {
                let error = new Error(r.statusText);
                throw error
            }
        })
        .then((data) => {
            if (data.status===200){
                dispatch(userSymbolsSlice.actions.updateSymbolsArray(data.json))
            }
        })
        .catch((e) => {
            console.log('Error: ' + e.message);
        })
}